import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/shareIcons/pencil_fill.svg'


const _hoisted_1 = { class: "bg-modal w-maxC" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "contactInputGrid mtop-12" }
const _hoisted_4 = { style: {"grid-column":"left","justify-self":"end","margin-top":"0.45rem"} }
const _hoisted_5 = { class: "row mtop-04" }

import { ref } from 'vue';
import { formatMatricule } from '@/functions/lu.js';
import relationshipapi from "@/api/relationshipapi";
import { useI18n } from "vue-i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'cnsModify',
  props: {
  cns: {
    type: Object,
    required: true,
  },
},
  emits: ['openEditCnsNumber'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emits = __emit

const props = __props

const isCnsActive = ref(props.cns.isCnsActive);
const currCns = ref(props.cns);

async function updateIsCnsActive() {
  const relationshipId = props.cns.relationshipId;
  const newIsCnsActive = !isCnsActive.value;
  //Update front
  isCnsActive.value = newIsCnsActive;
  currCns.value.isCnsActive = newIsCnsActive;
  //Update back
  await relationshipapi.updateIsCnsActive(relationshipId, newIsCnsActive);
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_switchGroup = _resolveComponent("switchGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_text_item, {
      txt: _unref(t)('patient.cns.modifyCard.title'),
      styles: "font-l"
    }, null, 8, ["txt"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_item, {
        txt: _unref(formatMatricule)(props.cns.cnsAffiliationNumber),
        styles: "main-m"
      }, null, 8, ["txt"]),
      _createVNode(_component_button_group, {
        class: "mleft-02 psides-06",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('openEditCnsNumber')))
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "img-grey-dark"
          }, null, -1)
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.cns.modifyCard.useCnsNumber')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_switchGroup, {
          active: isCnsActive.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (updateIsCnsActive()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_item, {
              icon: "check",
              class: _normalizeClass(isCnsActive.value ? 'img-white' : '')
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mtop-04" }, null, -1))
  ]))
}
}

})